module.exports = __webpack_public_path__ + "public/StoreIcon/delete.png?e453d0a3";